module.exports = __webpack_public_path__ + "img/bluesky31.47d0c4b9.jpg";